export enum BatType {
  LEFT_HANDED_BATSMAN = "LEFT_HANDED_BATSMAN",
  RIGHT_HANDED_BATSMAN = "RIGHT_HANDED_BATSMAN",
}

export const batTypeNames: Record<BatType, string> = {
  LEFT_HANDED_BATSMAN: "Left Handed Batsman",
  RIGHT_HANDED_BATSMAN: "Right Handed Batsman",
};
